/*
 * @Descripttion: 直播教师选择
 * @Author: gouyang
 * @Date: 2021-01-08 09:55:49
 * @LastEditors: jiyong_gou
 * @LastEditTime: 2022-12-29 15:45:41
 */

import React, { useCallback, useEffect, useRef } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { getTeacher } from '../../../redux/action/base.action';

interface P {
  value?: any;
  onChange?: (...args: any) => void;
}

const SelectTeacher = React.forwardRef<any, P>((props) => {
  const { value, onChange } = props;
  const page = useRef<number>(0);
  const loadingRef = useRef(false);
  const _onSearch = useRef<(...args: any) => void>(() => {});
  const { totalPages, teacherList } = useSelector((store: any) => ({
    totalPages: store.Base.totalPages,
    teacherList: store.Base.teacherList,
  }));

  const onSearch = useCallback(async (keyword?: any) => {
    // 应曹永承要求，不传subjectIdString
    // const subjectIdString = subjectIds.join('|');
    // const params: { [s: string]: string | number } = { subjectIdString, page: 0 };
    const params: { [s: string]: string | number } = { page: 0 };
    if (keyword) params.keyWord = keyword;
    loadingRef.current = true;
    page.current = 0;
    try {
      await getTeacher(params);
    } finally {
      loadingRef.current = false;
    }
  }, []);

  const onSelect = useCallback(() => {
    onSearch('');
  }, [onSearch]);

  const onPopupScroll = useCallback(
    async (e: any) => {
      e.persist();
      const { target } = e;
      const preHeight = target.scrollHeight;
      const reachedBottom =
        (target.scrollTop as number) + (target.offsetHeight as number) >
        target.scrollHeight - 5;
      if (!reachedBottom || loadingRef.current || page.current >= totalPages - 1) {
        return;
      }
      /**
       * 不必初始化教师列表
       * 在基本信息里面已经初始过
       */
      loadingRef.current = true;
      const nextPage = page.current + 1;
      try {
        const { status }: any = await getTeacher({ page: nextPage });
        if (status === 200) {
          page.current = nextPage;
          target.scrollTop = preHeight - 150;
        }
      } finally {
        loadingRef.current = false;
      }
    },
    [totalPages],
  );

  useEffect(() => {
    const debouncedSearch = _.debounce(onSearch, 800);
    _onSearch.current = debouncedSearch;
    return () => {
      debouncedSearch.cancel();
    };
  }, [onSearch]);

  return (
    <Select
      allowClear
      showSearch
      value={value}
      onChange={onChange}
      placeholder="请选择"
      optionFilterProp="children"
      onSearch={(keyword) => _onSearch.current(keyword)}
      onSelect={onSelect}
      onPopupScroll={onPopupScroll}
      onDropdownVisibleChange={(open) => {
        if (open) {
          onSelect();
        }
      }}
      getPopupContainer={(triggerNode: any) => triggerNode.parentElement}
    >
      {teacherList.map((item: any) => (
        <Select.Option
          value={`${item.userId}&&${item.orgName || ''}&&${item.name}`}
          key={item.userId}
        >
          {item.name}（{item.phone}）
        </Select.Option>
      ))}
    </Select>
  );
});

export default SelectTeacher;
